module.exports = __webpack_public_path__ + "img/lg_ring_r_i_1_0@3x.33fe0090.png";